import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { PageHeaderProps } from './PageHeader.props'

import './PageHeader.scss'

const PageHeader: FC<PageHeaderProps> = ({ title, children, className, totalCountTitle }) => (
  <div className={cn('page-header', className)}>
    <h2 className="page-header__title">{title}</h2>
    <div className="page-header__content">{children}</div>
  </div>
)

export default PageHeader
